export const apiUrl = 'https://www.quikr.com/core/quikrcars';
export const GTM_ACCOUNT_ID = 'GTM-M32VP9';
export const sortByOptions = {
    timeDesc: 'Recently Posted',
    priceAsc: 'Lowest Price',
    priceDesc: 'Highest Price',
    year: 'Latest Model',
    kms_Driven: 'Kms Driven'
}
export const upfrontFilters = {
    "71": {
        "identifiers": [
            {
                "identifierText": "Brand_name",
                "displayText": "Brand"
            },
            {
                "identifierText": "Model",
                "displayText": "Model"
            },
            {
                "identifierText": "Fuel_Type",
                "displayText": "Fuel"
            },
            {
                "identifierText": "bikePointId",
                "displayText": "Quikr Store"
            },
            {
                "identifierText": "Year",
                "displayText": "Mfg Year"
            },
            {
                "identifierText": "Color",
                "displayText": "Color"
            }
        ]
    },
    "72": {
        "identifiers": [
            {
                "identifierText": "Brand_name",
                "displayText": "Brand"
            },
            {
                "identifierText": "Model",
                "displayText": "Model"
            },
            {
                "identifierText": "Year",
                "displayText": "Mfg Year"
            },
            {
                "identifierText": "bikePointId",
                "displayText": "Quikr Store"
            }
        ]
    },
    "74": {
        "identifiers": [
            {
                "identifierText": "Product_Type",
                "displayText": "Product Type"
            }
        ]
    },
    "139": {
        "identifiers": [
            {
                "identifierText": "Vehicle_Type",
                "displayText": "Vehicle Type"
            }
        ]
    }
}

export const assuredTextPoints = {
    "71": [
        "7 Day Return Policy",
        "97 Checkpoints Inspected on All Cars",
        "Hassle-free Paper Transfer & RTO Services",
        "Great EMI Options Available"
    ],
    "72": [
        "7 Day Return Policy",
        "85 Checkpoints Inspected on All Bikes",
        "Hassle-free Paper Transfer & RTO Services",
        "6 Months Warranty Available"
    ]
}

export const benefitsAmount = 700;

export const assuredShortTextPoints = {
    "71": [
        "7 Day Return Policy",
        "97 Checkpoints Inspected",
        "Hassle-free Paper Transfer",
        "Great EMI Options Available"
    ],
    "72": [
        "7 Day Return Policy",
        "85 Checkpoints Inspected",
        "Hassle-free Paper Transfer",
        "6 Months Warranty Available"
    ]
}

export const inspectedTextPoints = {
    "71": [
        "97 Checkpoints Inspected",
        "6 Months Warranty Available",
        "Buy with confidence from <p>Quikr Preferred Sellers <p>"
    ],
    "72": [
        "85 Checkpoints Inspected",
        "6 Months Warranty Available",
        "Buy with confidence from <p>Quikr Preferred Sellers <p>"
    ]
}


export const topCityList = [
    {'name':'Ahmedabad', id:'22', 'carsCategoryId':161, 'bikesCategoryId':162},
    {'name':'Bangalore', id:'23', 'carsCategoryId':263, 'bikesCategoryId':264},
    {'name':'Chandigarh', id:'24', 'carsCategoryId':365, 'bikesCategoryId':366},
    {'name':'Chennai', id:'25', 'carsCategoryId':467, 'bikesCategoryId':468},
    {'name':'Coimbatore', id:'26', 'carsCategoryId':569, 'bikesCategoryId':570},
    {'name':'Delhi', id:'27', 'carsCategoryId':671, 'bikesCategoryId':672},
    {'name':'Hyderabad', id:'28', 'carsCategoryId':773, 'bikesCategoryId':774},
    {'name':'Kochi', id:'29', 'carsCategoryId':875, 'bikesCategoryId':876},
    {'name':'Kolkata', id:'30', 'carsCategoryId':977, 'bikesCategoryId':978},
    {'name':'Mumbai', id:'31', 'carsCategoryId':1079, 'bikesCategoryId':1080},
    {'name':'Pune', id:'33', 'carsCategoryId':1283, 'bikesCategoryId':1284},
    {'name':'Gurgaon', id:'132222', 'carsCategoryId':13222205001, 'bikesCategoryId':13222205002},
    {'name':'Jaipur', id:'152222', 'carsCategoryId':15222205001, 'bikesCategoryId':15222205002},
    {'name':'Lucknow', id:'162222', 'carsCategoryId':16222205001, 'bikesCategoryId':16222205002},
    {'name':'Noida', id:'201301', 'carsCategoryId':18222208931, 'bikesCategoryId':18222208934},
    {'name':'NaviMumbai', id:'400701', 'carsCategoryId':18222208661, 'bikesCategoryId':18222208664}
];

export const smartFilterOrder = [
    {
        title: 'Select Your City',
        filterName: 'City'
    },{
        title: 'Price/Budget',
        filterName: 'Price'
    },{
        title: 'Brand',
        filterName: 'Brand_name'
    },{
        title: 'Model',
        filterName: 'Model'
    },{
        title: 'Fuel Type',
        filterName: 'Fuel_Type'
    },{
        title: 'Nearby localities',
        filterName: 'Locality'
    }
];

export const preferredVehicleOffers = {
    "71": [
        {
            "title": "Earn {value} QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Inspected Car",
            "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "2.0",
                "maxAmount": "10000"
            }
        },{
            "title": "Earn {value} on visit of Quikr Preferred Seller Store",
            "subtext": "in QCash",
            "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
            "offerType": {
                "type": "FLAT",
                "maxAmount": "500"
            },
            "code": "CAR500"
        }
    ],
    "72": [
        {
            "title": "Earn {value} QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Inspected Bike",
            "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "4.0",
                "maxAmount": "5000"
            }
        },{
            "title": "Earn {value} on visit of Quikr Preferred Seller Store",
            "subtext": "in QCash",
            "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
            "offerType": {
                "type": "FLAT",
                "maxAmount": "500"
            },
            "code": "BIKE500"
        }
    ]
}

export const assuredVehicleOffers = {
    "71": [
        {
            "title": "Discount of {value} using QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Assured Car",
            "icon": "https://teja10.kuikr.com/images/car/icon-burn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "1.0",
                "maxAmount": "10000"
            }
        },{
            "title": "Earn {value} QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Assured Car",
            "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "2.0",
                "maxAmount": "10000"
            }
        },{
            "title": "Earn {value} on visit of Quikr Car Store",
            "subtext": "in QCash and PayTM cash",
            "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
            "offerType": {
                "type": "FLAT",
                "maxAmount": "700"
            },
            "code": "CAR700"
        }
    ],
    "72": [
        {
            "title": "Discount of {value} using QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Assured Bike",
            "icon": "https://teja10.kuikr.com/images/car/icon-burn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "2.0",
                "maxAmount": "5000"
            }
        },{
            "title": "Earn {value} QCash",
            "highlightText": "QCash",
            "subtext": "on purchase of {this/any} Quikr Assured Bike",
            "icon": "https://teja10.kuikr.com/images/car/icon-earn.png",
            "offerType": {
                "type": "PERCENTAGE",
                "percentage": "4.0",
                "maxAmount": "5000"
            }
        },{
            "title": "Earn {value} on visit of Quikr Bike Point",
            "subtext": "in QCash and PayTM cash",
            "icon": "https://teja10.kuikr.com/images/car/icon-offer.png",
            "offerType": {
                "type": "FLAT",
                "maxAmount": "700"
            },
            "code": "BIKE700"
        }
    ]
}

export const stateList = [
    {'name': "Andaman Nicobar Islands", 'id': "1146884"},
    {'name': "Andhra Pradesh", 'id': "1146885"},
    {'name': "Arunachal Pradesh", 'id': "1146886"},
    {'name': "Assam", 'id': "1146887"},
    {'name': "Bihar", 'id': "1146888"},
    {'name': "Chattisgarh", 'id': "1146889"},
    {'name': "Dadra Nagar Haveli", 'id': "1146890"},
    {'name': "Daman Diu", 'id': "1146891"},
    {'name': "Gujarat", 'id': "1146894"},
    {'name': "Haryana", 'id': "1146895"},
    {'name': "Himachal Pradesh", 'id': "1146896"},
    {'name': "Jammu Kashmir", 'id': "1146897"},
    {'name': "Jharkhand", 'id': "1146898"},
    {'name': "Karnataka", 'id': "1146899"},
    {'name': "Kerala", 'id': "1146900"},
    {'name': "Lakshadweep", 'id': "1146901"},
    {'name': "Madhya Pradesh", 'id': "1146902"},
    {'name': "Maharashtra", 'id': "1146903"},
    {'name': "Manipur", 'id': "1146904"},
    {'name': "Meghalaya", 'id': "1146905"},
    {'name': "Mizoram", 'id': "1146906"},
    {'name': "Nagaland", 'id': "1146907"},
    {'name': "Orissa", 'id': "1146908"},
    {'name': "Punjab", 'id': "1146910"},
    {'name': "Rajasthan", 'id': "1146911"},
    {'name': "Sikkim", 'id': "1146912"},
    {'name': "Tamil Nadu", 'id': "1146913"},
    {'name': "Telangana", 'id': "1146920"},
    {'name': "Tripura", 'id': "1146914"},
    {'name': "Uttarakhand", 'id': "1146916"},
    {'name': "Uttar Pradesh", 'id': "1146915"},
    {'name': "West Bengal", 'id': "1146917"}
];



// WEBPACK FOOTER //
// ../q-cars/src/config.js